import React, { Component } from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import Testimonial from '../../category/common/Testimonial';
import { branch } from 'baobab-react/higher-order';

class TestimonialCarousel extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
    }

    render() {
        const {data} = this.props;

        const generateTestimonialList = (testimonials) => {
            if (Array.isArray(testimonials)) {
                return testimonials.map((testimonial, index) => {
                    return (
                        <Testimonial
                            key={`testimonial-${index + 1}`}
                            imgSrc1={testimonial.imgSrc1}
                            alt1={testimonial.alt1}
                            quote={testimonial.quote}
                            submitted={testimonial.submitted}
                        />
                    );
                })
            }
        }

        const testimonialList = generateTestimonialList(data);

        return (
            <Carousel
                autoPlay={true}
                // emulateTouch={true}
                interval={6000}
                showArrows={true}
                showThumbs={false}
                showStatus={false}
                infiniteLoop={true}
                dynamicHeight={false}
                preventMovementUntilSwipeScrollTolerance={true}
                swipeScrollTolerance={30}
                className="testimonial-carousel"
            >
                {testimonialList}
            </Carousel>
        );

    }


}

export default branch({}, TestimonialCarousel);


// WEBPACK FOOTER //
// ./src/pages/components/page/TestimonialCarousel.js